import React from "react";
import {FaMobileAlt} from "react-icons/fa";
import ContentPage from "../../components/ContentPage";

const EULA = () => (
	<ContentPage
		icon={<FaMobileAlt/>}
		eyebrow="APP LICENSE"
		title="End-User License Agreement"
		summary="This agreement governs your personal use of the Barkr mobile application provided by Barkr Ltd."
		updated="Last updated 10 June 2023">
		<p>
			This End-User License Agreement (“Agreement”) is a legal agreement between you (“User”) and
			Barkr Ltd. (“Barkr”) regarding the Barkr mobile application (“App”). By downloading,
			installing, or using the App, you agree to this Agreement.
		</p>

		<h2>1. App purpose</h2>
		<p>
			Barkr is a social platform that helps dog owners connect, communicate, and arrange suitable
			walks or playdates. You must meet the minimum age shown during registration and in the
			applicable store listing.
		</p>

		<h2>2. License grant</h2>
		<p>
			Subject to this Agreement, Barkr grants you a limited, non-exclusive, revocable,
			non-transferable license to use the App for personal, non-commercial purposes.
		</p>

		<h2>3. Usage restrictions</h2>
		<p>You agree not to:</p>
		<ul>
			<li>Reverse engineer, modify, copy, or distribute the App except where permitted by law.</li>
			<li>Use the App for unlawful, harmful, fraudulent, or unauthorized purposes.</li>
			<li>Violate the rights of other members or send unsolicited or abusive content.</li>
			<li>Circumvent security measures or access the App through unauthorized means.</li>
		</ul>

		<h2>4. Privacy and data</h2>
		<p>
			Barkr processes information, including approximate location data, to provide nearby
			connections and other features. Data is handled as described in our{" "}
			<a href="/privacy">Privacy Policy</a>.
		</p>

		<h2>5. Intellectual property</h2>
		<p>
			Barkr retains all rights, title, and interest in the App, including its software, design,
			content, trademarks, and other intellectual property.
		</p>

		<h2>6. Your responsibilities</h2>
		<p>
			You agree to provide accurate registration information, follow applicable laws, and take
			responsibility for content you share and interactions you arrange through Barkr.
		</p>

		<h2>7. Advertising and subscriptions</h2>
		<p>
			The App may display advertisements and offer paid plans or features. Prices, renewal terms,
			and included features are shown before purchase and handled through the applicable app store.
		</p>

		<h2>8. Disclaimer of warranty</h2>
		<p>
			To the extent permitted by law, the App is provided “as is” and “as available” without
			warranties of uninterrupted availability or fitness for a particular purpose.
		</p>

		<h2>9. Limitation of liability</h2>
		<p>
			To the maximum extent permitted by law, Barkr is not liable for indirect, incidental,
			consequential, special, or exemplary damages arising from use of the App.
		</p>

		<h2>10. Termination</h2>
		<p>
			Barkr may suspend or terminate access when this Agreement is violated. You may terminate the
			Agreement by deleting your account and ceasing use of the App.
		</p>

		<h2>11. Governing law</h2>
		<p>
			This Agreement is governed by the laws of Bulgaria, subject to any mandatory rights that
			apply in your country of residence.
		</p>

		<h2>12. Changes</h2>
		<p>
			We may update this Agreement. Material changes will be communicated through the App or
			another appropriate channel, and continued use constitutes acceptance of the updated terms.
		</p>

		<h2>13. Contact</h2>
		<p>
			Questions about this Agreement can be sent to{" "}
			<a href="mailto:support@barkr.app">support@barkr.app</a>.
		</p>

		<div className="content-page__notice">
			By using Barkr, you acknowledge that you have read, understood, and agreed to this Agreement.
		</div>
	</ContentPage>
);

export default EULA;
